import React from 'react'

const ChevronsUpDownIcon = props => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width={props.width ? props.width : 24}
         height={props.height ? props.height : 24} viewBox="0 0 24 24" fill="none" stroke="currentColor"
         strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="m7 15 5 5 5-5"/>
        <path d="m7 9 5-5 5 5"/>
    </svg>
)

export default ChevronsUpDownIcon;


// WEBPACK FOOTER //
// ./src/assets/ChevronsUpDownIcon.jsx